import {
  ScanLine, Package, Users, Wallet, BarChart3, ShieldCheck,
} from "lucide-react";

export const PUBLIC_NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Pricing", to: "/pricing" },
  { label: "Features", to: "/features" },
  { label: "Contact Us", to: "/contact" },
];

export const PUBLIC_FEATURES = [
  { icon: ScanLine, title: "Barcode Billing", body: "Generate & print barcodes for every saree. Scan to bill in seconds." },
  { icon: Package, title: "Live Inventory", body: "Know exactly which piece is on the shelf, sold, or reserved for a customer." },
  { icon: Users, title: "Customer Register", body: "Store addresses, phone numbers and visit history — no more paper diaries." },
  { icon: Wallet, title: "Revenue & Expenses", body: "GST-ready invoices. See profit for today, this month, this year." },
  { icon: BarChart3, title: "One-Glance Dashboard", body: "The numbers that matter, in the language every small owner understands." },
  { icon: ShieldCheck, title: "Made for India", body: "Rupees, GST, WhatsApp-friendly. Works even on modest devices." },
];

export const PUBLIC_PLANS = [
  { name: "Starter", price: 499, features: ["Up to 500 products", "1 store", "POS + Inventory", "GST invoicing"] },
  { name: "Pro", price: 999, highlight: true, features: ["Unlimited products", "Staff & attendance", "Customer register", "Priority support"] },
  { name: "Business", price: 1999, features: ["Multi-store ready", "Advanced analytics", "Custom reports", "Dedicated support"] },
];

export const ABOUT_BULLETS = [
  "Built for saree, kurta & dress sellers — not generic retail",
  "14-day free trial, no credit card required",
  "Works on modest phones and shared shop computers",
  "Made in India — INR, GST states, local support mindset",
];
